export default "__VITE_ASSET__Cc_4Dz47__"